// ===========================
// Main JavaScript
// ===========================
document.addEventListener('DOMContentLoaded', ()=>{
    // Initialize all components
    initMobileMenu();
    initSmoothScroll();
    initScrollHeader();
    initContactForm();
    initActiveNavLinks();
});
// ===========================
// Mobile Menu Toggle
// ===========================
function initMobileMenu() {
    const mobileMenuBtn = document.getElementById('mobileMenuBtn');
    const navMenu = document.getElementById('navMenu');
    if (!mobileMenuBtn || !navMenu) return;
    mobileMenuBtn.addEventListener('click', ()=>{
        navMenu.classList.toggle('active');
        mobileMenuBtn.classList.toggle('active');
        // Toggle aria-expanded for accessibility
        const isExpanded = navMenu.classList.contains('active');
        mobileMenuBtn.setAttribute('aria-expanded', isExpanded);
        // Prevent body scroll when menu is open
        if (isExpanded) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = '';
    });
    // Close menu when clicking on a link
    const navLinks = navMenu.querySelectorAll('.nav-link');
    navLinks.forEach((link)=>{
        link.addEventListener('click', ()=>{
            navMenu.classList.remove('active');
            mobileMenuBtn.classList.remove('active');
            mobileMenuBtn.setAttribute('aria-expanded', 'false');
            document.body.style.overflow = '';
        });
    });
    // Close menu when clicking outside
    document.addEventListener('click', (e)=>{
        const isClickInsideMenu = navMenu.contains(e.target);
        const isClickOnMenuBtn = mobileMenuBtn.contains(e.target);
        if (!isClickInsideMenu && !isClickOnMenuBtn && navMenu.classList.contains('active')) {
            navMenu.classList.remove('active');
            mobileMenuBtn.classList.remove('active');
            mobileMenuBtn.setAttribute('aria-expanded', 'false');
            document.body.style.overflow = '';
        }
    });
    // Close menu on window resize to desktop
    let resizeTimer;
    window.addEventListener('resize', ()=>{
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(()=>{
            if (window.innerWidth > 768 && navMenu.classList.contains('active')) {
                navMenu.classList.remove('active');
                mobileMenuBtn.classList.remove('active');
                mobileMenuBtn.setAttribute('aria-expanded', 'false');
                document.body.style.overflow = '';
            }
        }, 250);
    });
}
// ===========================
// Smooth Scroll for Anchor Links
// ===========================
function initSmoothScroll() {
    const links = document.querySelectorAll('a[href^="#"]');
    links.forEach((link)=>{
        link.addEventListener('click', (e)=>{
            const href = link.getAttribute('href');
            // Skip if href is just "#"
            if (href === '#') return;
            const target = document.querySelector(href);
            if (target) {
                e.preventDefault();
                const headerOffset = 80; // Account for fixed header
                const elementPosition = target.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
                // Update URL without scrolling
                history.pushState(null, null, href);
            }
        });
    });
}
// ===========================
// Header Scroll Effect
// ===========================
function initScrollHeader() {
    const header = document.getElementById('header');
    if (!header) return;
    let lastScrollTop = 0;
    window.addEventListener('scroll', ()=>{
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        // Add shadow on scroll
        if (scrollTop > 50) header.classList.add('scrolled');
        else header.classList.remove('scrolled');
        lastScrollTop = scrollTop;
    });
}
// ===========================
// Active Navigation Links
// ===========================
function initActiveNavLinks() {
    const sections = document.querySelectorAll('section[id]');
    const navLinks = document.querySelectorAll('.nav-link');
    if (sections.length === 0 || navLinks.length === 0) return;
    window.addEventListener('scroll', ()=>{
        const scrollPosition = window.pageYOffset + 100;
        sections.forEach((section)=>{
            const sectionTop = section.offsetTop;
            const sectionHeight = section.offsetHeight;
            const sectionId = section.getAttribute('id');
            if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) navLinks.forEach((link)=>{
                link.classList.remove('active');
                if (link.getAttribute('href') === `#${sectionId}`) link.classList.add('active');
            });
        });
    });
}
// ===========================
// Contact Form Handler
// ===========================
function initContactForm() {
    const form = document.getElementById('contactForm');
    const formStatus = document.getElementById('formStatus');
    if (!form || !formStatus) return;
    form.addEventListener('submit', async (e)=>{
        e.preventDefault();
        // Get form data
        const formData = {
            name: form.querySelector('#name').value.trim(),
            email: form.querySelector('#email').value.trim(),
            phone: form.querySelector('#phone').value.trim(),
            message: form.querySelector('#message').value.trim()
        };
        // Validate required fields
        if (!formData.phone || !formData.message) {
            showFormStatus('error', "\u05D0\u05E0\u05D0 \u05DE\u05DC\u05D0 \u05D0\u05EA \u05DB\u05DC \u05D4\u05E9\u05D3\u05D5\u05EA \u05D4\u05D7\u05D5\u05D1\u05D4");
            return;
        }
        // Validate phone number (basic Israeli phone validation)
        const phoneRegex = /^0[2-9]\d{1,2}-?\d{7}$/;
        if (!phoneRegex.test(formData.phone.replace(/\s/g, ''))) {
            showFormStatus('error', "\u05DE\u05E1\u05E4\u05E8 \u05D4\u05D8\u05DC\u05E4\u05D5\u05DF \u05D0\u05D9\u05E0\u05D5 \u05EA\u05E7\u05D9\u05DF");
            return;
        }
        // Validate email if provided
        if (formData.email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(formData.email)) {
                showFormStatus('error', "\u05DB\u05EA\u05D5\u05D1\u05EA \u05D4\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05D0\u05D9\u05E0\u05D4 \u05EA\u05E7\u05D9\u05E0\u05D4");
                return;
            }
        }
        // Disable submit button and show loading state
        const submitBtn = form.querySelector('button[type="submit"]');
        const originalBtnText = submitBtn.textContent;
        submitBtn.disabled = true;
        submitBtn.textContent = "\u05E9\u05D5\u05DC\u05D7...";
        try {
            // Send form data to API
            const response = await fetch('/api/contactus', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });
            if (response.ok) {
                showFormStatus('success', "\u05EA\u05D5\u05D3\u05D4! \u05D4\u05D4\u05D5\u05D3\u05E2\u05D4 \u05E0\u05E9\u05DC\u05D7\u05D4 \u05D1\u05D4\u05E6\u05DC\u05D7\u05D4. \u05E0\u05D7\u05D6\u05D5\u05E8 \u05D0\u05DC\u05D9\u05DA \u05D1\u05D4\u05E7\u05D3\u05DD!");
                form.reset();
            } else throw new Error("\u05E9\u05D2\u05D9\u05D0\u05D4 \u05D1\u05E9\u05DC\u05D9\u05D7\u05EA \u05D4\u05D8\u05D5\u05E4\u05E1");
        } catch (error) {
            console.error('Form submission error:', error);
            showFormStatus('error', "\u05D0\u05D9\u05E8\u05E2\u05D4 \u05E9\u05D2\u05D9\u05D0\u05D4 \u05D1\u05E9\u05DC\u05D9\u05D7\u05EA \u05D4\u05D8\u05D5\u05E4\u05E1. \u05E0\u05E1\u05D4 \u05E9\u05D5\u05D1 \u05D0\u05D5 \u05E6\u05D5\u05E8 \u05E7\u05E9\u05E8 \u05D9\u05E9\u05D9\u05E8\u05D5\u05EA \u05D1\u05D8\u05DC\u05E4\u05D5\u05DF.");
        } finally{
            // Re-enable submit button
            submitBtn.disabled = false;
            submitBtn.textContent = originalBtnText;
        }
    });
    // Helper function to show form status
    function showFormStatus(type, message) {
        formStatus.className = `form-status ${type}`;
        formStatus.textContent = message;
        formStatus.style.display = 'block';
        // Add shake animation for errors
        if (type === 'error') {
            formStatus.classList.add('shake');
            setTimeout(()=>formStatus.classList.remove('shake'), 500);
        }
        // Auto-hide success messages after 5 seconds
        if (type === 'success') setTimeout(()=>{
            formStatus.style.display = 'none';
        }, 5000);
    }
}
// ===========================
// Utility Functions
// ===========================
// Debounce function for performance optimization
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = ()=>{
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// Throttle function for scroll events
function throttle(func, limit) {
    let inThrottle;
    return function(...args) {
        if (!inThrottle) {
            func.apply(this, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// Check if element is in viewport
function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}
// Export functions for use in other scripts
window.emathUtils = {
    debounce,
    throttle,
    isInViewport
};

//# sourceMappingURL=emath.co.il.5803cb66.js.map
